import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { updateDefault } from '@euroland/format-number';
import { updateDefaultDateTime } from '@euroland/libs';
// import reportWebVitals from "./reportWebVitals";
// import registerServiceWorker from "./registerServiceWorker";
import "./locale";

import { store } from "./store";
import "./styles/index.scss";
import { getCompanySettings } from "./services";
import { setSettings } from "./store/slice/settings/main";
import { i18n } from "@euroland/libs";

import { waitForDocumentReady, isFunction, stringifyError } from "@euroland/libs";
import { loadConfiguredCustomStylesheet, loadSettingEUCalendar, loadVariableStylesByTemplate, transitionDecimalDigitsToFormatNumber } from "./utils";
import { FORMAT_NUMBER, POSITIVE_NUMBER_FORMAT } from "./constant/common";
import { getCurrenciesNameAction } from "./actions";

const initApp = setting => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    // </React.StrictMode>
  );

  return setting;
};

const publicCompanySettings = settings => {
  const settingsData = settings.data.settings;
  const { thousandsSeparator, negativeNumberFormat, decimalSeparator, decimalDigits, positiveNumberFormat } =  settingsData.format;
  let formatNumber = transitionDecimalDigitsToFormatNumber(decimalDigits);
  let useLatinNumber = settingsData.useLatinNumber
  if (window.appSettings.language !== "ar-ae" ) useLatinNumber = true
  settingsData.currencies = settingsData.currencies.sort((a, b) => a.order - b.order);
    // default format number
  updateDefault({
    groupingSeparator: thousandsSeparator,
    decimalSeparator,
    format: formatNumber || FORMAT_NUMBER,
    nagativeFormatPattern: negativeNumberFormat,
    positiveFormatPattern: positiveNumberFormat || POSITIVE_NUMBER_FORMAT,
    useLatinNumbers: useLatinNumber,

  });

  updateDefaultDateTime({
    timezone: settingsData.timezone,
    settingFormat: {...settingsData.format, fullDate: "dddd MMMM YYYY", fullDateTime: "dddd MMMM YYYY hh:mm"},
    useLatinNumbers: useLatinNumber

  })
  store.dispatch(setSettings(settingsData));
  return settings;
};

const loadCustomPharses = settings => {
  if (settings.data.customPhrases) {
    i18n.setCustomPhrases(settings.data.customPhrases.reduce((s, c) => ({ ...s, [c.key]: c.value }), {}));
  }
  return settings;
};

const loadCurrenciesName = settings => {
  let currenciesCode = settings.data.settings.currencies.map(item => item.code)

  // remove duplicate code when setting file xml wrong
  currenciesCode = Array.from(new Set(currenciesCode).values())
  store.dispatch(getCurrenciesNameAction(currenciesCode))
  return settings
}

function integrate(settings) {
  Promise.all([/*isIFrame(),*/ /*integrationScriptPromise,*/ waitForDocumentReady()])
    .then(() => {
      // Refer to https://gitlab.euroland.com/tools/flipit/integration/-/blob/master/doc/integration-api.md for more detail of implementing integration.
      if (window.euroland && isFunction(window.euroland.integrate)) {
        window.euroland.integrate({
          toolName: window.appSettings.integrationAppName,
          companyCode: window.appSettings.companyCode,
          version: window.appSettings.companyCodeVersion,
          lang: window.appSettings.language,
          allowedParentDomains: settings.data.settings.allowedParentDomains || ['*']
        });
      } else {
        throw new Error('Unknown Integration API "window.euroland.integrate".');
      }
    })
    .catch(err => {
      // TODO: just log on dev environment.
      console.warn(`Something wrong occurred with integration script. Stack Traces: ${stringifyError(err)}`);
    });
}

function integrateGoogleAnalytics(settings) {
  const googleAnalyticsEnabled = settings.data.settings.googleAnalyticsEnabled ?? false;
  const googleAnalyticUrl = window.appSettings.googleAnalyticUrl ?? null;
  if (googleAnalyticsEnabled && !!googleAnalyticUrl) {
    let src = document.createElement("script");
    src.src = googleAnalyticUrl;
    (document.head || document.documentElement).appendChild(src);
  }
  return settings;
}

getCompanySettings()
  .then(integrateGoogleAnalytics)
  .then(loadCurrenciesName)
  .then(loadConfiguredCustomStylesheet)
  .then(loadVariableStylesByTemplate)
  .then(publicCompanySettings)
  .then(loadCustomPharses)
  .then(initApp)
  .then((settings) => loadSettingEUCalendar({}, settings))
  .then(integrate);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
//registerServiceWorker();
